import { Modules } from '@enum/central/modules.enum';
import { TenantPerm } from '@enum/tenant/permission/tenant-perm.enum';

export const FinanceSection = [
  {
    section: 'Financeiro',
    permission: [
      '*',
      TenantPerm.Accounts_View,
      TenantPerm.Governance_View,
      TenantPerm.Cashboxes_View,
      TenantPerm.Cards_View,
      TenantPerm.BankRecons_View,
    ],
  },
  {
    title: 'Contas a pagar',
    permission: ['*', TenantPerm.Accounts_View],
    root: true,
    icon: 'receipt_long',
    page: '/painel/financas/contas-a-pagar',
    bullet: 'dot',
  },
  {
    title: 'Contas a receber',
    permission: ['*', TenantPerm.Accounts_View],
    root: true,
    icon: 'request_quote',
    page: '/painel/financas/contas-a-receber',
    bullet: 'dot',
  },
  {
    title: 'Governança',
    module: Modules.ANTIFRAUD,
    permission: ['*', TenantPerm.Governance_View],
    root: true,
    icon: 'verified_user',
    page: '/painel/governanca',
    bullet: 'dot',
  },
  // "Créditos" saiu do menu (dono, 21/09/2026): a tela continua em
  // `/painel/creditos` e o acesso é o indicador de créditos da barra superior.
  // "Premium e IA" virou Configurações › Inteligência artificial.
  {
    title: 'Caixas',
    permission: ['*', TenantPerm.Cashboxes_View],
    root: true,
    icon: 'account_balance_wallet',
    page: '/painel/financas/caixas/listar',
    bullet: 'dot',
  },
  {
    title: 'Cartões de crédito',
    permission: ['*', TenantPerm.Cards_View],
    root: true,
    icon: 'credit_card',
    page: '/painel/financas/cartoes',
    bullet: 'dot',
  },
  {
    title: 'Conciliação bancária',
    permission: ['*', TenantPerm.BankRecons_View],
    root: true,
    icon: 'fact_check',
    page: '/painel/financas/conciliacao/bancaria',
    bullet: 'dot',
  },
];
